export const multipleBetTypes = [
    `DBL`,
    `TBL`,
    `2F3`,
    `TRX`,
    `PAT`,
    `4F`,
    `2F4`,
    `3F4`,
    `YAN`,
    `L15`,
    `5F`,
    `2F5`,
    `3F5`,
    `4F5`,
    `CAN`,
    `L31`,
    `6F`,
    `2F6`,
    `3F6`,
    `4F6`,
    `5F6`,
    `HNZ`,
    `L63`,
    `7F`,
    `2F7`,
    `3F7`,
    `4F7`,
    `5F7`,
    `6F7`,
    `SHNZ`,
    `8F`,
    `2F8`,
    `3F8`,
    `4F8`,
    `5F8`,
    `6F8`,
    `7F8`,
    `GOL`,
    `9F`,
    `2F9`,
    `3F9`,
    `8F9`,
    `10F`,
    `2F10`,
    `3F10`,
    `9F10`,
    `11F`,
    `2F11`,
    `3F11`,
    `10F11`,
    `12F`,
    `2F12`,
    `3F12`,
    `11F12`,
    `13F`,
    `2F13`,
    `3F13`,
    `12F13`,
    `14F`,
    `2F14`,
    `3F14`,
    `13F14`,
    `15F`,
    `2F15`,
    `3F15`,
    `14F15`,
    `16F`,
    `2F16`,
    `3F16`,
    `15F16`,
    `17F`,
    `2F17`,
    `3F17`,
    `16F17`,
    `18F`,
    `2F18`,
    `3F18`,
    `17F18`,
    `19F`,
    `2F19`,
    `3F19`,
    `18F19`,
    `20F`,
    `2F20`,
    `3F20`,
    `19F20`,
    `21F`,
    `2F21`,
    `3F21`,
    `20F21`,
    `22F`,
    `2F22`,
    `3F22`,
    `21F22`,
    `23F`,
    `2F23`,
    `3F23`,
    `22F23`,
    `24F`,
    `2F24`,
    `3F24`,
    `23F24`,
    `25F`,
    `2F25`,
    `3F25`,
    `24F25`,
];
